module.exports = __webpack_public_path__ + "static/media/age_rating_7.d18c98fa.svg";